import React from "react";
import ReactDOM from "react-dom/client";

// Geist Sans (L73 revamp). 400 + 600 only. The `latin-NNN.css` files emit a
// single `@font-face` rule each and are the smallest preset @fontsource ships;
// Vite picks the woff2/woff under `files/` and rewrites them with hashed
// asset URLs, so the @fontsource self-host works without extra Vite plumbing.
// Geist Mono is intentionally NOT installed (Crítico §6.5 — saves ~40KB; the
// `ui-monospace` chain is visually equivalent at our 12px tabular cells).
//
// Preload note: a literal `<link rel="preload">` to a node_modules path would
// not survive Vite's hash-rewrite. The simplest correct path is to let the
// CSS @font-face bring the woff2 in lazily — the Geist face swaps in late on
// the first cold paint (`font-display: swap` in @fontsource's CSS), and the
// system fallback in `--font-sans` carries the layout in the meantime. This
// is the §4 row-6 fallback ("ship without preload — font swaps in late,
// acceptable per the spec"); upgrading to a real Vite plugin is a v1.1
// follow-up if a noticeable FOUT shows up in production.
import "@fontsource/geist-sans/latin-400.css";
import "@fontsource/geist-sans/latin-600.css";

// Nimbus design tokens + component CSS. `dist/index.css` is the file that
// contains the **hashed** selectors (`.nimbus-button_base__fymkre0`, etc.)
// that the component JS actually applies to the DOM via the `@nimbus-ds/
// styles` module exports. `dist/styles.css` ships only the unhashed
// variants (`.nimbus-button_base`) which the components never emit — that
// file is for downstream consumers that want to author against stable
// names. Importing the wrong one leaves every `<Button>` unstyled.
import "@nimbus-ds/styles/dist/index.css";

import { App } from "./App";
import "./styles.css";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
